















































import { Getter, State, namespace } from 'vuex-class';
import { Vue, Component, Watch, Prop, Provide } from 'vue-property-decorator';
import { Menu, Submenu, MenuItem, MenuItemGroup } from 'element-ui';
import { Route, RouteConfig } from 'vue-router';
import event from '@acgn/herm/src/util/event';

const authModule = namespace('auth');

@Component({
  components: {
    [Menu.name]: Menu,
    [Submenu.name]: Submenu,
    [MenuItem.name]: MenuItem,
    [MenuItemGroup.name]: MenuItemGroup
  }
})
export default class Side extends Vue {
  private get activeRouter() {
    const mi = this.searchPathInMenus(this.route, this.menusLocal);
    if (mi) {
      return mi.path.split('/').slice(0, 3).join('/');
    } else {
      return null;
    }
  }
  @Prop({ default: false }) private visible!: boolean;

  @State('route') private route!: any;
  @Getter('apps/currentMenus') private menus!: SideMenuItem[];

  /**
   * 直接使用menus在异步路由的情况下不行，
   * 可能是因为activeRouter没有正常返回值，需要如下workaround:
   */
  private menusLocal: SideMenuItem[] = [];
  private collapsed = false;

  private get sideMenuAsideStyle() {
    const style: any = {};
    if (this.collapsed) {
      style.width = '64px';
    } else {
      style.width = '200px';
    }
    return style;
  }

  @Watch('menus')
  private watchMenus(newVal: any) {
    setTimeout(() => {
      this.menusLocal = newVal;
    });
  }

  private created() {
    this.menusLocal = this.menus;
  }

  /**
   * 查找与路由最匹配的菜单。
   * 比如有这样两个菜单：A: /a/b、B: /a/b/c，路由是/a/b/c/d，那么应该找到B菜单。
   * 这样的目的是，因为有的路由没有菜单，但是还是要高亮选中左侧的菜单，那么就应该选中与当前路由最匹配的。
   */
  private searchPathInMenus(matchingRoute: Route, menus2search: SideMenuItem[]): SideMenuItem | null {
    const sortedMenus = ((menus2search || []).concat([])).sort((m1, m2) => {
      return m2.path.length - m1.path.length;
    });
    for (const mi of sortedMenus) {
      if (mi.children) {
        const inSub = this.searchPathInMenus(matchingRoute, mi.children);
        if (inSub) {
          return inSub;
        }
      }
      if (matchingRoute.meta.highlightMenuPath) {
        // 如果在路由的meta中配置了highlightMenuPath，则优先使用它
        let matchingRouteStr = '';
        if ((typeof matchingRoute.meta.highlightMenuPath) === 'function') {
          matchingRouteStr = matchingRoute.meta.highlightMenuPath(matchingRoute);
        } else {
          matchingRouteStr = String(matchingRoute.meta.highlightMenuPath);
        }
        if (matchingRouteStr.indexOf(mi.path) === 0) {
          return mi;
        }
      }
      if (matchingRoute.path.indexOf(mi.path) === 0) {
        return mi;
      }
    }
    return null;
  }

  /**
   * 判断路由是否是 root 节点
   * @param item 路由项
   */
  private isRootRoute(item: any): boolean {
    const { children } = item;

    // 1. 没有子菜单
    if (!children) {
      return true;
    }

    // 2. 子菜单数量为 1 && path === ''
    if (children && children.length === 1 && children[0].path === '') {
      return true;
    }

    return false;
  }

  private onSideClick(evt: Event) {
    if (evt.currentTarget === evt.target) {
      this.$emit('close');
    }
  }

  private toggleCollapsed() {
    this.collapsed = !this.collapsed;
    event.emit('$togglerenderMenu');
  }

  private handleMenuOpen() {
    //
  }

  private handleMenuClose() {
    //
  }

  private handleMenuSelect() {
    this.$emit('close');
  }
}
